export default {
  'pages.layouts.userLayout.title':
    'Ant Design 是西湖区最具影响力的 Web 设计规范',
  'pages.login.accountLogin.tab': '账户密码登录',
  'pages.login.accountLogin.errorMessage':
    '错误的用户名和密码(admin/ant.design)',
  'pages.login.failure': '登录失败，请重试！',
  'pages.login.success': '登录成功！',
  'pages.login.username.placeholder': '用户名: admin or user',
  'pages.login.username.required': '用户名是必填项！',
  'pages.login.password.placeholder': '密码: ant.design',
  'pages.login.password.required': '密码是必填项！',
  'pages.login.phoneLogin.tab': '手机号登录',
  'pages.login.phoneLogin.errorMessage': '验证码错误',
  'pages.login.phoneNumber.placeholder': '请输入手机号！',
  'pages.login.phoneNumber.required': '手机号是必填项！',
  'pages.login.phoneNumber.invalid': '不合法的手机号！',
  'pages.login.captcha.placeholder': '请输入验证码！',
  'pages.login.captcha.required': '验证码是必填项！',
  'pages.login.phoneLogin.getVerificationCode': '获取验证码',
  'pages.getCaptchaSecondText': '秒后重新获取',
  'pages.login.submit': '登录',
  'pages.login.loginWith': '其他登录方式 :',
  'pages.login.registerAccount': '注册账户',
  'pages.login.brandTitle': 'Aspire.Build. Connect.',
  'pages.login.brandSubtitle': '专业的物业管理解决方案',
  'pages.login.welcomeTitle': '欢迎回来',
  'pages.login.welcomeSubtitle': '请登录您的账户以继续使用',
  'pages.login.username.label': '用户名',
  'pages.login.password.label': '密码',
  'pages.login.recaptcha.required': '请完成人机验证',
  'pages.login.recaptcha.error': '验证码加载失败，请刷新页面重试',
  'pages.login.failure.message': '登录失败，请检查用户名和密码',
  'pages.login.rememberMe': '记住我',
  'pages.login.forgotPassword': '忘记密码？',
  'pages.login.forgotPassword.title': '忘记密码',
  'pages.login.forgotPassword.fetchMasked': '查询脱敏邮箱',
  'pages.login.forgotPassword.maskedLabel': '脱敏邮箱',
  'pages.login.forgotPassword.maskedLoaded': '已获取脱敏邮箱',
  'pages.login.forgotPassword.email': '邮箱',
  'pages.login.forgotPassword.emailPlaceholder': '请输入完整邮箱',
  'pages.login.forgotPassword.emailRequired': '请输入邮箱',
  'pages.login.forgotPassword.emailInvalid': '邮箱格式不正确',
  'pages.login.forgotPassword.verifyEmail': '验证邮箱',
  'pages.login.forgotPassword.verifyOk': '邮箱验证通过',
  'pages.login.forgotPassword.verifyFail': '用户名与邮箱不匹配',
  'pages.login.forgotPassword.verifyFirst': '请先验证邮箱',
  'pages.login.forgotPassword.sendCode': '发送验证码',
  'pages.login.forgotPassword.resendIn': '{seconds} 秒后重发',
  'pages.login.forgotPassword.sendOk': '验证码已发送',
  'pages.login.forgotPassword.sendFail': '发送验证码失败',
  'pages.login.forgotPassword.code': '邮箱验证码',
  'pages.login.forgotPassword.codePlaceholder': '请输入验证码',
  'pages.login.forgotPassword.codeRequired': '请输入验证码',
  'pages.login.forgotPassword.newPassword': '新密码',
  'pages.login.forgotPassword.newPasswordRequired': '请输入新密码',
  'pages.login.forgotPassword.passwordMin': '密码至少 6 位',
  'pages.login.forgotPassword.confirmPassword': '确认新密码',
  'pages.login.forgotPassword.confirmRequired': '请再次输入新密码',
  'pages.login.forgotPassword.passwordMismatch': '两次输入的密码不一致',
  'pages.login.forgotPassword.submit': '重置密码',
  'pages.login.forgotPassword.resetOk': '密码重置成功，请使用新密码登录',
  'pages.login.forgotPassword.resetFail': '重置密码失败',
  'pages.login.forgotPassword.requestFailed': '请求失败，请稍后重试',
  'pages.login.forgotPassword.usernameRequired': '请输入用户名',
  'pages.login.forgotPassword.stepAccount': '确认账号',
  'pages.login.forgotPassword.stepEmail': '验证邮箱',
  'pages.login.forgotPassword.stepCode': '邮箱验证码',
  'pages.login.forgotPassword.stepPassword': '设置新密码',
  'pages.login.forgotPassword.stepAccountDesc': '请输入登录用户名，系统将显示脱敏邮箱供您核对。',
  'pages.login.forgotPassword.stepEmailDesc': '请输入与账号绑定的完整邮箱地址。',
  'pages.login.forgotPassword.stepCodeDesc': '向您的邮箱发送验证码，并填写邮件中的验证码。',
  'pages.login.forgotPassword.stepPasswordDesc': '请设置登录用的新密码。',
  'pages.login.forgotPassword.contentTitle.step1': '找回您的密码',
  'pages.login.forgotPassword.contentTitle.step2': '验证密保邮箱',
  'pages.login.forgotPassword.contentTitle.step3': '填写验证码',
  'pages.login.forgotPassword.contentTitle.step4': '设置新密码',
  'pages.login.forgotPassword.codeSentTo': '验证码已发送至 {email}',
  'pages.login.forgotPassword.next': '下一步',
  'pages.login.forgotPassword.prev': '上一步',
  'pages.login.forgotPassword.finish': '完成重置',
  'pages.login.forgotPassword.sendCodeFirst': '请先点击发送验证码',
  'pages.login.forgotPassword.codeSentHint': '邮件已发送，请查收',
  'pages.welcome.link': '欢迎使用',
  'pages.welcome.alertMessage': '更快更强的重型组件，已经发布。',
  'pages.404.subTitle': '抱歉，您访问的页面不存在。',
  'pages.404.buttonText': '返回首页',
  'pages.admin.subPage.title': ' 这个页面只有 admin 权限才能查看',
  'pages.admin.subPage.alertMessage':
    'umi ui 现已发布，欢迎使用 npm run ui 启动体验。',
  'pages.searchTable.createForm.newRule': '新建规则',
  'pages.searchTable.updateForm.ruleConfig': '规则配置',
  'pages.searchTable.updateForm.basicConfig': '基本信息',
  'pages.searchTable.updateForm.ruleName.nameLabel': '规则名称',
  'pages.searchTable.updateForm.ruleName.nameRules': '请输入规则名称！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '规则描述',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '请输入至少五个字符',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    '请输入至少五个字符的规则描述！',
  'pages.searchTable.updateForm.ruleProps.title': '配置规则属性',
  'pages.searchTable.updateForm.object': '监控对象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '规则模板',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '规则类型',
  'pages.searchTable.updateForm.schedulingPeriod.title': '设定调度周期',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '开始时间',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '请选择开始时间！',
  'pages.searchTable.titleDesc': '描述',
  'pages.searchTable.ruleName': '规则名称为必填项',
  'pages.searchTable.titleCallNo': '服务调用次数',
  'pages.searchTable.titleStatus': '状态',
  'pages.searchTable.nameStatus.default': '关闭',
  'pages.searchTable.nameStatus.running': '运行中',
  'pages.searchTable.nameStatus.online': '已上线',
  'pages.searchTable.nameStatus.abnormal': '异常',
  'pages.searchTable.titleUpdatedAt': '上次调度时间',
  'pages.searchTable.exception': '请输入异常原因！',
  'pages.searchTable.titleOption': '操作',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '订阅警报',
  'pages.searchTable.title': '查询表格',
  'pages.searchTable.new': '新建',
  'pages.searchTable.chosen': '已选择',
  'pages.searchTable.item': '项',
  'pages.searchTable.totalServiceCalls': '服务调用次数总计',
  'pages.searchTable.tenThousand': '万',
  'pages.searchTable.batchDeletion': '批量删除',
  'pages.searchTable.batchApproval': '批量审批',

  // 轮播图管理页面
  'pages.banner.title': '轮播图管理',
  'pages.banner.create': '新建轮播图',
  'pages.banner.refreshCache': '刷新缓存',
  'pages.banner.batchDelete': '批量删除',
  'pages.banner.confirmDelete': '确定要删除这个轮播图吗？',
  'pages.banner.confirmRefreshCache': '确定要刷新轮播图缓存吗？',
  'pages.banner.confirmBatchDelete': '确定要删除选中的 {count} 个轮播图吗？',
  'pages.banner.deleteSuccess': '删除轮播图成功',
  'pages.banner.batchDeleteSuccess': '批量删除轮播图成功',
  'pages.banner.refreshCacheSuccess': '刷新轮播图缓存成功',
  'pages.banner.getDetailFailed': '获取轮播图详情失败',
  'pages.banner.deleteFailed': '删除轮播图失败',
  'pages.banner.batchDeleteFailed': '批量删除轮播图失败',
  'pages.banner.refreshCacheFailed': '刷新轮播图缓存失败',
  'pages.banner.selectItemsWarning': '请选择要删除的轮播图',
  'pages.banner.columns.index': '序号',
  'pages.banner.columns.image': '图片',
  'pages.banner.columns.title': '标题',
  'pages.banner.columns.type': '类型',
  'pages.banner.columns.linkTarget': '跳转目标',
  'pages.banner.columns.sort': '排序',
  'pages.banner.columns.status': '状态',
  'pages.banner.columns.platform': '平台',
  'pages.banner.columns.startTime': '开始时间',
  'pages.banner.columns.endTime': '结束时间',
  'pages.banner.columns.operations': '操作',
  'pages.banner.actions.view': '查看',
  'pages.banner.actions.edit': '编辑',
  'pages.banner.actions.delete': '删除',
  'pages.banner.status.online': '上架',
  'pages.banner.status.offline': '下架',
  'pages.banner.linkType.none': '不跳转',
  'pages.banner.linkType.external': '外部链接',
  'pages.banner.linkType.internal': '内部页面',
  'pages.banner.linkType.product': '商品详情',
  'pages.banner.platform.all': '全部',
  'pages.banner.platform.ios': 'iOS',
  'pages.banner.platform.android': 'Android',
  'pages.banner.platform.h5': 'H5',
  'pages.banner.detail.title': '轮播图详情',
  'pages.banner.detail.basicInfo': '基本信息',
  'pages.banner.detail.timeInfo': '时间信息',
  'pages.banner.detail.remarks': '备注',
  'pages.banner.detail.createTime': '创建时间',
  'pages.banner.detail.updateTime': '更新时间',

  // 轮播图表单
  'pages.banner.form.editTitle': '编辑轮播图',
  'pages.banner.form.createTitle': '新建轮播图',
  'pages.banner.form.titleLabel': '轮播图标题',
  'pages.banner.form.titlePlaceholder': '请输入轮播图标题',
  'pages.banner.form.titleRequired': '请输入轮播图标题',
  'pages.banner.form.titleMaxLength': '标题不能超过100个字符',
  'pages.banner.form.imageLabel': '轮播图图片',
  'pages.banner.form.imageRequired': '请上传轮播图图片',
  'pages.banner.form.uploadTab': '本地上传',
  'pages.banner.form.urlTab': '图片URL',
  'pages.banner.form.uploadImageTypeError': '只能上传图片文件!',
  'pages.banner.form.uploadImageSizeError': '图片大小不能超过5MB!',
  'pages.banner.form.uploadSuccess': '图片上传成功',
  'pages.banner.form.uploadFailed': '图片上传失败',
  'pages.banner.form.updateSuccess': '更新轮播图成功',
  'pages.banner.form.createSuccess': '创建轮播图成功',
  'pages.banner.form.updateFailed': '更新轮播图失败',
  'pages.banner.form.createFailed': '创建轮播图失败',
  'pages.banner.form.urlPlaceholder': '请输入图片URL地址',
  'pages.banner.form.uploadHint': '点击或拖拽图片到此处更换',
  'pages.banner.form.uploading': '上传中...',
  'pages.banner.form.uploadPrompt': '拖拽或点击上传',
  'pages.banner.form.uploadFormatHint': '支持JPG/PNG/GIF/WEBP格式，最大2MB',
  'pages.banner.form.imageSizeRecommend': '推荐尺寸：750x300像素，图片将显示为完整URL，但只存储相对路径到数据库',
  'pages.banner.form.linkTypeLabel': '跳转类型',
  'pages.banner.form.linkTypeRequired': '请选择跳转类型',
  'pages.banner.form.linkTargetLabel': '跳转目标',
  'pages.banner.form.linkTargetPlaceholder': '请输入跳转链接、路由或ID',
  'pages.banner.form.sortOrderLabel': '排序值',
  'pages.banner.form.sortOrderPlaceholder': '请输入排序值',
  'pages.banner.form.sortOrderHelp': '数值越小排序越靠前，新建时自动获取下一个可用值',
  'pages.banner.form.statusLabel': '状态',
  'pages.banner.form.statusRequired': '请选择状态',
  'pages.banner.form.platformLabel': '平台',
  'pages.banner.form.platformRequired': '请选择平台',
  'pages.banner.form.remarksLabel': '备注信息',
  'pages.banner.form.remarksPlaceholder': '请输入备注信息',

  // 公告管理页面
  'pages.announcement.title': '公告管理',
  'pages.announcement.create': '新建公告',
  'pages.announcement.batchDelete': '批量删除',
  'pages.announcement.confirmDelete': '确定要删除这个公告吗？',
  'pages.announcement.confirmBatchDelete': '确定要删除选中的 {count} 个公告吗？',
  'pages.announcement.deleteSuccess': '删除公告成功',
  'pages.announcement.batchDeleteSuccess': '成功删除 {count} 个公告',
  'pages.announcement.deleteFailed': '删除公告失败',
  'pages.announcement.batchDeleteFailed': '批量删除公告失败',
  'pages.announcement.getListFailed': '获取公告列表失败',
  'pages.announcement.columns.image': '图片',
  'pages.announcement.columns.title': '公告标题',
  'pages.announcement.columns.type': '公告类型',
  'pages.announcement.columns.status': '状态',
  'pages.announcement.columns.startTime': '生效时间',
  'pages.announcement.columns.endTime': '失效时间',
  'pages.announcement.columns.createTime': '创建时间',
  'pages.announcement.columns.operations': '操作',
  'pages.announcement.actions.view': '查看',
  'pages.announcement.actions.edit': '编辑',
  'pages.announcement.actions.delete': '删除',
  'pages.announcement.status.enabled': '启用',
  'pages.announcement.status.disabled': '禁用',
  'pages.announcement.status.unknown': '未知',
  'pages.announcement.type.system': '系统公告',
  'pages.announcement.type.activity': '活动公告',
  'pages.announcement.type.maintenance': '维护公告',
  'pages.announcement.type.other': '其他',
  'pages.announcement.type.unknown': '未知',
  'pages.announcement.tag.pinned': '置顶',
  'pages.announcement.tag.urgent': '紧急',
  'pages.announcement.language.chinese': '中文',
  'pages.announcement.language.english': '英文',
  'pages.announcement.detail.title': '公告详情',
  'pages.announcement.detail.basicInfo': '基本信息',
  'pages.announcement.detail.timeInfo': '时间信息',
  'pages.announcement.detail.attachments': '附件',
  'pages.announcement.detail.content': '公告内容',
  'pages.announcement.preview.title': '公告预览',

  // 公告表单
  'pages.announcement.form.editTitle': '编辑{type}',
  'pages.announcement.form.createTitle': '新建{type}',
  'pages.announcement.form.systemAnnouncement': '系统公告',
  'pages.announcement.form.urgentNotice': '紧急通知',
  'pages.announcement.form.titleLabel': '公告标题',
  'pages.announcement.form.titlePlaceholder': '请输入公告标题',
  'pages.announcement.form.titleRequired': '请输入公告标题',
  'pages.announcement.form.titleMaxLength': '标题不能超过100个字符',
  'pages.announcement.form.typeLabel': '公告类型',
  'pages.announcement.form.typeRequired': '请选择公告类型',
  'pages.announcement.form.statusLabel': '是否启用',
  'pages.announcement.form.statusRequired': '请选择是否启用',
  'pages.announcement.form.startTimeLabel': '生效时间',
  'pages.announcement.form.startTimeRequired': '请选择生效时间',
  'pages.announcement.form.endTimeLabel': '失效时间',
  'pages.announcement.form.endTimeRequired': '请选择失效时间',
  'pages.announcement.form.endTimeValidation': '失效时间必须晚于生效时间',
  'pages.announcement.form.pinnedLabel': '是否置顶',
  'pages.announcement.form.attachmentsLabel': '附件上传',
  'pages.announcement.form.attachmentsHelp': '推荐尺寸：750x300像素，支持多张图片上传',
  'pages.announcement.form.attachmentsTypeError': '只能上传图片文件!',
  'pages.announcement.form.attachmentsSizeError': '图片大小不能超过5MB!',
  'pages.announcement.form.attachmentsUploadSuccess': '{fileName} 上传成功',
  'pages.announcement.form.attachmentsUploadFailed': '{fileName} 上传失败',
  'pages.announcement.form.attachmentsUploadedCount': '已上传 {count} 张图片，点击或拖拽继续添加',
  'pages.announcement.form.attachmentsUploadPrompt': '点击或拖拽图片到此处上传',
  'pages.announcement.form.attachmentsFormatHint': '支持JPG/PNG/GIF/WEBP格式，最大5MB，可上传多张图片',
  'pages.announcement.form.contentLabel': '公告内容',
  'pages.announcement.form.contentRequired': '请输入公告内容',
  'pages.announcement.form.updateSuccess': '更新公告成功',
  'pages.announcement.form.createSuccess': '创建公告成功',
  'pages.announcement.form.submitFailed': '提交公告失败',

  // 紧急通知管理页面
  'pages.urgent.title': '紧急通知管理',
  'pages.urgent.create': '新建紧急通知',
  'pages.urgent.batchDelete': '批量删除',
  'pages.urgent.confirmDelete': '确定要删除这个紧急通知吗？',
  'pages.urgent.confirmBatchDelete': '确定要删除选中的 {count} 个紧急通知吗？',
  'pages.urgent.deleteSuccess': '删除紧急通知成功',
  'pages.urgent.batchDeleteSuccess': '成功删除 {count} 个紧急通知',
  'pages.urgent.deleteFailed': '删除紧急通知失败',
  'pages.urgent.batchDeleteFailed': '批量删除紧急通知失败',
  'pages.urgent.getListFailed': '获取紧急通知列表失败',
  'pages.urgent.columns.image': '图片',
  'pages.urgent.columns.title': '通知标题',
  'pages.urgent.columns.type': '通知类型',
  'pages.urgent.columns.status': '状态',
  'pages.urgent.columns.startTime': '生效时间',
  'pages.urgent.columns.endTime': '失效时间',
  'pages.urgent.columns.createTime': '创建时间',
  'pages.urgent.columns.operations': '操作',
  'pages.urgent.actions.view': '查看',
  'pages.urgent.actions.edit': '编辑',
  'pages.urgent.actions.delete': '删除',
  'pages.urgent.status.enabled': '启用',
  'pages.urgent.status.disabled': '禁用',
  'pages.urgent.status.unknown': '未知',
  'pages.urgent.language.chinese': '中文',
  'pages.urgent.language.english': '英文',
  'pages.urgent.detail.title': '紧急通知详情',
  'pages.urgent.detail.basicInfo': '基本信息',
  'pages.urgent.detail.timeInfo': '时间信息',
  'pages.urgent.detail.attachments': '附件',
  'pages.urgent.detail.content': '通知内容',
  'pages.urgent.preview.title': '紧急通知预览',

  // 紧急通知表单
  'pages.urgent.form.editTitle': '编辑紧急通知',
  'pages.urgent.form.createTitle': '新建紧急通知',
  'pages.urgent.form.titleLabel': '通知标题',
  'pages.urgent.form.titlePlaceholder': '请输入通知标题',
  'pages.urgent.form.titleRequired': '请输入通知标题',
  'pages.urgent.form.titleMaxLength': '标题不能超过100个字符',
  'pages.urgent.form.typeLabel': '通知类型',
  'pages.urgent.form.typeRequired': '请选择通知类型',
  'pages.urgent.form.statusLabel': '是否启用',
  'pages.urgent.form.statusRequired': '请选择是否启用',
  'pages.urgent.form.startTimeLabel': '生效时间',
  'pages.urgent.form.startTimeRequired': '请选择生效时间',
  'pages.urgent.form.endTimeLabel': '失效时间',
  'pages.urgent.form.endTimeRequired': '请选择失效时间',
  'pages.urgent.form.endTimeValidation': '失效时间必须晚于生效时间',
  'pages.urgent.form.pinnedLabel': '是否置顶',
  'pages.urgent.form.attachmentsLabel': '附件上传',
  'pages.urgent.form.attachmentsHelp': '推荐尺寸：750x300像素，支持多张图片上传',
  'pages.urgent.form.attachmentsTypeError': '只能上传图片文件!',
  'pages.urgent.form.attachmentsSizeError': '图片大小不能超过5MB!',
  'pages.urgent.form.attachmentsUploadSuccess': '{fileName} 上传成功',
  'pages.urgent.form.attachmentsUploadFailed': '{fileName} 上传失败',
  'pages.urgent.form.attachmentsUploadedCount': '已上传 {count} 张图片，点击或拖拽继续添加',
  'pages.urgent.form.attachmentsUploadPrompt': '点击或拖拽图片到此处上传',
  'pages.urgent.form.attachmentsFormatHint': '支持JPG/PNG/GIF/WEBP格式，最大5MB，可上传多张图片',
  'pages.urgent.form.contentLabel': '通知内容',
  'pages.urgent.form.contentRequired': '请输入通知内容',
  'pages.urgent.form.updateSuccess': '更新紧急通知成功',
  'pages.urgent.form.createSuccess': '创建紧急通知成功',
  'pages.urgent.form.submitFailed': '提交紧急通知失败',

  // 社区公告管理页面
  'pages.community.title': '社区公告管理',
  'pages.community.create': '新建社区公告',
  'pages.community.batchDelete': '批量删除',
  'pages.community.confirmDelete': '确定要删除这个社区公告吗？',
  'pages.community.confirmBatchDelete': '确定要删除选中的 {count} 个社区公告吗？',
  'pages.community.deleteSuccess': '删除社区公告成功',
  'pages.community.batchDeleteSuccess': '成功删除 {count} 个社区公告',
  'pages.community.deleteFailed': '删除社区公告失败',
  'pages.community.batchDeleteFailed': '批量删除社区公告失败',
  'pages.community.getListFailed': '获取社区公告列表失败',
  'pages.community.columns.image': '图片',
  'pages.community.columns.title': '公告标题',
  'pages.community.columns.type': '公告类型',
  'pages.community.columns.status': '状态',
  'pages.community.columns.startTime': '生效时间',
  'pages.community.columns.endTime': '失效时间',
  'pages.community.columns.createTime': '创建时间',
  'pages.community.columns.operations': '操作',
  'pages.community.actions.view': '查看',
  'pages.community.actions.edit': '编辑',
  'pages.community.actions.delete': '删除',
  'pages.community.status.enabled': '启用',
  'pages.community.status.disabled': '禁用',
  'pages.community.status.unknown': '未知',
  'pages.community.language.chinese': '中文',
  'pages.community.language.english': '英文',
  'pages.community.detail.title': '社区公告详情',
  'pages.community.detail.basicInfo': '基本信息',
  'pages.community.detail.timeInfo': '时间信息',
  'pages.community.detail.attachments': '附件',
  'pages.community.detail.content': '公告内容',
  'pages.community.preview.title': '社区公告预览',

  // 社区公告表单
  'pages.community.form.editTitle': '编辑社区公告',
  'pages.community.form.createTitle': '新建社区公告',
  'pages.community.form.titleLabel': '公告标题',
  'pages.community.form.titlePlaceholder': '请输入公告标题',
  'pages.community.form.titleRequired': '请输入公告标题',
  'pages.community.form.titleMaxLength': '标题不能超过100个字符',
  'pages.community.form.typeLabel': '公告类型',
  'pages.community.form.typeRequired': '请选择公告类型',
  'pages.community.form.statusLabel': '是否启用',
  'pages.community.form.statusRequired': '请选择是否启用',
  'pages.community.form.startTimeLabel': '生效时间',
  'pages.community.form.startTimeRequired': '请选择生效时间',
  'pages.community.form.endTimeLabel': '失效时间',
  'pages.community.form.endTimeRequired': '请选择失效时间',
  'pages.community.form.endTimeValidation': '失效时间必须晚于生效时间',
  'pages.community.form.contentLabel': '公告内容',
  'pages.community.form.contentRequired': '请输入公告内容',
  'pages.community.form.pinnedLabel': '是否置顶',
  'pages.community.form.attachmentsLabel': '附件上传',
  'pages.community.form.attachmentsHelp': '推荐尺寸：750x300像素，支持多张图片上传',
  'pages.community.form.attachmentsTypeError': '只能上传图片文件!',
  'pages.community.form.attachmentsSizeError': '图片大小不能超过5MB!',
  'pages.community.form.attachmentsUploadSuccess': '{fileName} 上传成功',
  'pages.community.form.attachmentsUploadFailed': '{fileName} 上传失败',
  'pages.community.form.attachmentsUploadedCount': '已上传 {count} 张图片，点击或拖拽继续添加',
  'pages.community.form.attachmentsUploadPrompt': '点击或拖拽图片到此处上传',
  'pages.community.form.attachmentsFormatHint': '支持JPG/PNG/GIF/WEBP格式，最大5MB，可上传多张图片',
  'pages.community.form.updateSuccess': '更新社区公告成功',
  'pages.community.form.createSuccess': '创建社区公告成功',
  'pages.community.form.submitFailed': '提交社区公告失败',
  'pages.community.form.submitData': '提交社区公告数据:',

  // 宴会厅管理页面
  'pages.hall.title': '宴会厅出租管理',
  'pages.hall.create': '新增宴会厅',
  'pages.hall.batchDelete': '批量删除',
  'pages.hall.confirmDelete': '确定要删除这个宴会厅吗？',
  'pages.hall.confirmBatchDelete': '确定要删除选中的 {count} 个宴会厅吗？',
  'pages.hall.deleteSuccess': '删除宴会厅成功',
  'pages.hall.batchDeleteSuccess': '批量删除宴会厅成功',
  'pages.hall.deleteFailed': '删除宴会厅失败',
  'pages.hall.batchDeleteFailed': '批量删除宴会厅失败',
  'pages.hall.getListFailed': '获取宴会厅列表失败',
  'pages.hall.refreshCacheSuccess': '刷新缓存成功',
  'pages.hall.refreshCacheFailed': '刷新缓存失败',
  'pages.hall.getDetailFailed': '获取宴会厅详情失败',
  'pages.hall.selectDeleteWarning': '请选择要删除的宴会厅',
  'pages.hall.confirmRefreshCache': '确定要刷新宴会厅缓存吗？',
  'pages.hall.refreshCacheDescription': '刷新后将重新加载所有宴会厅数据',
  'pages.hall.refreshCacheButton': '刷新缓存',
  'pages.hall.columns.name': '宴会厅名称',
  'pages.hall.columns.title': '标题',
  'pages.hall.columns.carouselImages': '轮播图预览',
  'pages.hall.columns.status': '状态',
  'pages.hall.columns.sort': '排序',
  'pages.hall.columns.operations': '操作',
  'pages.hall.actions.view': '查看',
  'pages.hall.actions.edit': '编辑',
  'pages.hall.actions.delete': '删除',
  'pages.hall.status.enabled': '启用',
  'pages.hall.status.disabled': '禁用',
  'pages.hall.detail.title': '宴会厅详情',
  'pages.hall.detail.basicInfo': '基本信息',
  'pages.hall.detail.carouselImages': '轮播图',
  'pages.hall.language.chinese': '中文',
  'pages.hall.language.english': '英文',

  // 宴会厅表单
  'pages.hall.form.editTitle': '编辑宴会厅',
  'pages.hall.form.createTitle': '新增宴会厅',
  'pages.hall.form.nameLabel': '宴会厅名称',
  'pages.hall.form.namePlaceholder': '请输入宴会厅名称',
  'pages.hall.form.nameRequired': '请输入宴会厅名称',
  'pages.hall.form.nameMaxLength': '名称不能超过100个字符',
  'pages.hall.form.carouselImagesLabel': '轮播图',
  'pages.hall.form.carouselImagesUploadButton': '上传图片',
  'pages.hall.form.carouselImagesUploading': '上传中',
  'pages.hall.form.carouselImagesImageError': '只能上传图片文件!',
  'pages.hall.form.carouselImagesSizeError': '图片大小不能超过5MB!',
  'pages.hall.form.carouselImagesUploadSuccess': '图片上传成功',
  'pages.hall.form.carouselImagesUploadFailed': '图片上传失败',
  'pages.hall.form.carouselImagesUploadedCount': '已上传 {count} 张图片',
  'pages.hall.form.carouselImagesImageIndex': '图{index}',
  'pages.hall.form.statusLabel': '状态',
  'pages.hall.form.statusRequired': '请选择状态',
  'pages.hall.form.sortLabel': '排序值',
  'pages.hall.form.sortPlaceholder': '请输入排序值',
  'pages.hall.form.titleLabel': '标题',
  'pages.hall.form.titlePlaceholder': '请输入标题',
  'pages.hall.form.titleRequired': '请输入标题',
  'pages.hall.form.titleMaxLength': '标题不能超过200个字符',
  'pages.hall.form.descriptionLabel': '描述',
  'pages.hall.form.descriptionPlaceholder': '请输入描述信息',
  'pages.hall.form.descriptionMaxLength': '描述不能超过1000个字符',
  'pages.hall.form.updateSuccess': '更新宴会厅成功',
  'pages.hall.form.createSuccess': '创建宴会厅成功',
  'pages.hall.form.submitFailed': '操作失败',

  // 文档管理页面
  'pages.document.title': '文档管理',
  'pages.document.pageSubTitlePublicNote': '此处的文档对所有用户可见。',
  'pages.document.create': '新增文档',
  'pages.document.batchDelete': '批量删除',
  'pages.document.confirmDelete': '确定要删除这个文档吗？',
  'pages.document.confirmBatchDelete': '确定要删除选中的 {count} 个文档吗？',
  'pages.document.deleteSuccess': '删除文档成功',
  'pages.document.batchDeleteSuccess': '批量删除文档成功',
  'pages.document.deleteFailed': '删除文档失败',
  'pages.document.batchDeleteFailed': '批量删除文档失败',
  'pages.document.getListFailed': '获取文档列表失败',
  'pages.document.getDetailFailed': '获取文档详情失败',
  'pages.document.getMarksFailed': '获取文档标识失败',
  'pages.document.selectDeleteWarning': '请选择要删除的文档',
  'pages.document.columns.name': '文档名称',
  'pages.document.columns.category': '分类',
  'pages.document.columns.docType': '文档类型',
  'pages.document.columns.mark': '文档分类',
  'pages.document.columns.fileSize': '文件大小',
  'pages.document.columns.status': '状态',
  'pages.document.columns.description': '描述',
  'pages.document.columns.createdTime': '创建时间',
  'pages.document.columns.operations': '操作',
  'pages.document.actions.view': '查看',
  'pages.document.actions.edit': '编辑',
  'pages.document.actions.delete': '删除',
  'pages.document.category.normal': '普通文档',
  'pages.document.category.contract': '合同文档',
  'pages.document.category.unknown': '未知',
  'pages.document.status.enabled': '启用',
  'pages.document.status.disabled': '停用',
  'pages.document.detail.title': '文档详情',
  'pages.document.detail.basicInfo': '基本信息',
  'pages.document.detail.fileInfo': '文件信息',
  'pages.document.detail.timeInfo': '时间信息',
  'pages.document.detail.downloadFile': '下载文件',
  'pages.document.language.chinese': '中文',
  'pages.document.language.english': '英文',

  // 文档表单
  'pages.document.form.editTitle': '编辑文档',
  'pages.document.form.createTitle': '新增文档',
  'pages.document.form.documentInfo': '文档信息',
  'pages.document.form.basicInfo': '基本信息',
  'pages.document.form.fileUpload': '文件上传',
  'pages.document.form.docNameLabel': '标题',
  'pages.document.form.docNamePlaceholder': '请输入标题',
  'pages.document.form.docNameRequired': '请输入标题',
  'pages.document.form.docNameMaxLength': '标题不能超过200个字符',
  'pages.document.form.descriptionLabel': '描述',
  'pages.document.form.descriptionPlaceholder': '请输入描述',
  'pages.document.form.descriptionMaxLength': '描述不能超过500个字符',
  'pages.document.form.docTypeLabel': '文件类型',
  'pages.document.form.docTypePlaceholder': '请选择文件类型',
  'pages.document.form.docTypeRequired': '请选择文件类型',
  'pages.document.form.markLabel': '文档分类',
  'pages.document.form.markPlaceholder': '请选择文档分类',
  'pages.document.form.markRequired': '请选择文档分类',
  'pages.document.form.statusLabel': '状态',
  'pages.document.form.statusPlaceholder': '请选择状态',
  'pages.document.form.statusRequired': '请选择状态',
  'pages.document.form.statusEnabled': '启用',
  'pages.document.form.statusDisabled': '停用',
  'pages.document.form.uploadButton': '点击上传文件',
  'pages.document.form.uploading': '上传中',
  'pages.document.form.uploadFileError': '只能上传 PDF、Word、Excel、PPT 或 TXT 文件!',
  'pages.document.form.uploadSizeError': '文件大小不能超过10MB!',
  'pages.document.form.uploadSuccess': '文件上传成功',
  'pages.document.form.uploadFailed': '文件上传失败',
  'pages.document.form.uploadRequired': '请上传文件',
  'pages.document.form.fileNameLabel': '文件名：',
  'pages.document.form.fileSizeLabel': '文件大小：',
  'pages.document.form.fileTypeLabel': '文件扩展名：',
  'pages.document.form.downloadOriginal': '下载原文件',
  'pages.document.form.updateSuccess': '更新文档成功',
  'pages.document.form.createSuccess': '创建文档成功',
  'pages.document.form.submitFailed': '操作失败',

  // 合同管理页面
  'pages.contract.title': '合同文档管理',
  'pages.contract.create': '新增合同文档',
  'pages.contract.batchDelete': '批量删除',
  'pages.contract.confirmDelete': '确定要删除这个合同文档吗？',
  'pages.contract.confirmBatchDelete': '确定要删除选中的 {count} 个合同文档吗？',
  'pages.contract.deleteSuccess': '删除合同文档成功',
  'pages.contract.batchDeleteSuccess': '批量删除合同文档成功',
  'pages.contract.deleteFailed': '删除合同文档失败',
  'pages.contract.batchDeleteFailed': '批量删除合同文档失败',
  'pages.contract.getListFailed': '获取合同文档列表失败',
  'pages.contract.getDetailFailed': '获取合同文档详情失败',
  'pages.contract.selectDeleteWarning': '请选择要删除的合同文档',
  'pages.contract.columns.name': '合同名称',
  'pages.contract.columns.category': '分类',
  'pages.contract.columns.docType': '文档类型',
  'pages.contract.columns.fileSize': '文件大小',
  'pages.contract.columns.status': '状态',
  'pages.contract.columns.description': '描述',
  'pages.contract.columns.createdTime': '创建时间',
  'pages.contract.columns.operations': '操作',
  'pages.contract.actions.view': '查看',
  'pages.contract.actions.edit': '编辑',
  'pages.contract.actions.delete': '删除',
  'pages.contract.category.normal': '普通文档',
  'pages.contract.category.contract': '合同文档',
  'pages.contract.category.unknown': '未知',
  'pages.contract.status.enabled': '启用',
  'pages.contract.status.disabled': '停用',
  'pages.contract.detail.title': '合同文档详情',
  'pages.contract.detail.basicInfo': '基本信息',
  'pages.contract.detail.fileInfo': '文件信息',
  'pages.contract.detail.timeInfo': '时间信息',
  'pages.contract.detail.downloadFile': '下载文件',
  'pages.contract.language.chinese': '中文',
  'pages.contract.language.english': '英文',

  // 合同表单
  'pages.contract.form.editTitle': '编辑合同文档',
  'pages.contract.form.createTitle': '新增合同文档',
  'pages.contract.form.contractInfo': '合同信息',
  'pages.contract.form.basicInfo': '基本信息',
  'pages.contract.form.fileUpload': '文件上传',
  'pages.contract.form.docNameLabel': '合同名称',
  'pages.contract.form.docNamePlaceholder': '请输入合同名称',
  'pages.contract.form.docNameRequired': '请输入合同名称',
  'pages.contract.form.docNameMaxLength': '合同名称不能超过200个字符',
  'pages.contract.form.descriptionLabel': '合同描述',
  'pages.contract.form.descriptionPlaceholder': '请输入合同描述',
  'pages.contract.form.descriptionMaxLength': '合同描述不能超过500个字符',
  'pages.contract.form.docTypeLabel': '文件类型',
  'pages.contract.form.docTypePlaceholder': '请选择文件类型',
  'pages.contract.form.docTypeRequired': '请选择文件类型',
  'pages.contract.form.statusLabel': '状态',
  'pages.contract.form.statusPlaceholder': '请选择状态',
  'pages.contract.form.statusRequired': '请选择状态',
  'pages.contract.form.statusEnabled': '启用',
  'pages.contract.form.statusDisabled': '停用',
  'pages.contract.form.uploadButton': '点击上传文件',
  'pages.contract.form.uploading': '上传中',
  'pages.contract.form.uploadFileError': '只能上传 PDF、Word、Excel、PPT 或 TXT 文件!',
  'pages.contract.form.uploadSizeError': '文件大小不能超过10MB!',
  'pages.contract.form.uploadSuccess': '文件上传成功',
  'pages.contract.form.uploadFailed': '文件上传失败',
  'pages.contract.form.uploadRequired': '请上传文件',
  'pages.contract.form.fileNameLabel': '文件名：',
  'pages.contract.form.fileSizeLabel': '文件大小：',
  'pages.contract.form.fileTypeLabel': '文件扩展名：',
  'pages.contract.form.downloadOriginal': '下载原文件',
  'pages.contract.form.updateSuccess': '更新合同文档成功',
  'pages.contract.form.createSuccess': '创建合同文档成功',
  'pages.contract.form.submitFailed': '操作失败',

  // 文档模版管理页面
  'pages.document.template.title': '文档模版',
  'pages.document.template.create': '新增文档',
  'pages.document.template.batchDelete': '批量删除',
  'pages.document.template.confirmDelete': '确定要删除这个模版吗？',
  'pages.document.template.confirmBatchDelete': '确定要删除选中的 {count} 个模版吗？',
  'pages.document.template.deleteSuccess': '删除模版成功',
  'pages.document.template.batchDeleteSuccess': '批量删除模版成功',
  'pages.document.template.deleteFailed': '删除模版失败',
  'pages.document.template.batchDeleteFailed': '批量删除模版失败',
  'pages.document.template.getListFailed': '获取模版列表失败',
  'pages.document.template.getDetailFailed': '获取模版详情失败',
  'pages.document.template.selectDeleteWarning': '请选择要删除的模版',
  'pages.document.template.columns.name': '模版名称',
  'pages.document.template.columns.docType': '文档类型',
  'pages.document.template.columns.mark': '文档分类',
  'pages.document.template.columns.fileSize': '文件大小',
  'pages.document.template.columns.status': '状态',
  'pages.document.template.columns.description': '描述',
  'pages.document.template.columns.createdBy': '创建人',
  'pages.document.template.columns.createdTime': '创建时间',
  'pages.document.template.columns.operations': '操作',
  'pages.document.template.actions.view': '查看',
  'pages.document.template.actions.edit': '编辑',
  'pages.document.template.actions.delete': '删除',
  'pages.document.template.status.enabled': '启用',
  'pages.document.template.status.disabled': '停用',
  'pages.document.template.detail.title': '模版详情',
  'pages.document.template.detail.basicInfo': '基本信息',
  'pages.document.template.detail.fileInfo': '文件信息',
  'pages.document.template.detail.timeInfo': '时间信息',
  'pages.document.template.detail.downloadFile': '下载文件',
  'pages.document.template.language.chinese': '中文',
  'pages.document.template.language.english': '英文',

  // 文档模版表单
  'pages.document.template.form.editTitle': '编辑模版',
  'pages.document.template.form.createTitle': '新增模版',
  'pages.document.template.form.documentInfo': '模版信息',
  'pages.document.template.form.basicInfo': '基本信息',
  'pages.document.template.form.fileUpload': '文件上传',
  'pages.document.template.form.docNameLabel': '模版名称',
  'pages.document.template.form.docNamePlaceholder': '请输入模版名称',
  'pages.document.template.form.docNameRequired': '请输入模版名称',
  'pages.document.template.form.docNameMaxLength': '模版名称不能超过200个字符',
  'pages.document.template.form.descriptionLabel': '模版描述',
  'pages.document.template.form.descriptionPlaceholder': '请输入模版描述',
  'pages.document.template.form.descriptionMaxLength': '模版描述不能超过500个字符',
  'pages.document.template.form.docTypeLabel': '文件类型',
  'pages.document.template.form.docTypePlaceholder': '请选择文件类型',
  'pages.document.template.form.docTypeRequired': '请选择文件类型',
  'pages.document.template.form.markLabel': '文档标识',
  'pages.document.template.form.markPlaceholder': '请选择文档标识',
  'pages.document.template.form.markRequired': '请选择文档标识',
  'pages.document.template.form.statusLabel': '状态',
  'pages.document.template.form.statusPlaceholder': '请选择状态',
  'pages.document.template.form.statusRequired': '请选择状态',
  'pages.document.template.form.statusEnabled': '启用',
  'pages.document.template.form.statusDisabled': '停用',
  'pages.document.template.form.uploadButton': '点击上传文件',
  'pages.document.template.form.uploading': '上传中',
  'pages.document.template.form.uploadFileError': '只能上传 PDF、Word、Excel、PPT 或 TXT 文件!',
  'pages.document.template.form.uploadSizeError': '文件大小不能超过10MB!',
  'pages.document.template.form.uploadSuccess': '文件上传成功',
  'pages.document.template.form.uploadFailed': '文件上传失败',
  'pages.document.template.form.uploadRequired': '请上传文件',
  'pages.document.template.form.fileNameLabel': '文件名：',
  'pages.document.template.form.fileSizeLabel': '文件大小：',
  'pages.document.template.form.fileTypeLabel': '文件扩展名：',
  'pages.document.template.form.downloadOriginal': '下载原文件',
  'pages.document.template.form.updateSuccess': '更新模版成功',
  'pages.document.template.form.createSuccess': '创建模版成功',
  'pages.document.template.form.submitFailed': '操作失败',

  // 常用文档（文件管理）页面
  'pages.document.instruction.title': '常用文档',
  'pages.document.instruction.create': '新增文档',
  'pages.document.instruction.batchDelete': '批量删除',
  'pages.document.instruction.confirmDelete': '确定要删除这条常用文档吗？',
  'pages.document.instruction.confirmBatchDelete': '确定要删除选中的 {count} 条常用文档吗？',
  'pages.document.instruction.deleteSuccess': '删除常用文档成功',
  'pages.document.instruction.batchDeleteSuccess': '批量删除常用文档成功',
  'pages.document.instruction.deleteFailed': '删除常用文档失败',
  'pages.document.instruction.batchDeleteFailed': '批量删除常用文档失败',
  'pages.document.instruction.getListFailed': '获取常用文档列表失败',
  'pages.document.instruction.getDetailFailed': '获取常用文档详情失败',
  'pages.document.instruction.selectDeleteWarning': '请选择要删除的常用文档',
  'pages.document.instruction.columns.name': '文档名称',
  'pages.document.instruction.columns.docType': '文档类型',
  'pages.document.instruction.columns.mark': '文档分类',
  'pages.document.instruction.columns.fileSize': '文件大小',
  'pages.document.instruction.columns.status': '状态',
  'pages.document.instruction.columns.description': '描述',
  'pages.document.instruction.columns.createdBy': '创建人',
  'pages.document.instruction.columns.createdTime': '创建时间',
  'pages.document.instruction.columns.operations': '操作',
  'pages.document.instruction.actions.view': '查看',
  'pages.document.instruction.actions.edit': '编辑',
  'pages.document.instruction.actions.delete': '删除',
  'pages.document.instruction.status.enabled': '启用',
  'pages.document.instruction.status.disabled': '停用',
  'pages.document.instruction.detail.title': '常用文档详情',
  'pages.document.instruction.detail.basicInfo': '基本信息',
  'pages.document.instruction.detail.fileInfo': '文件信息',
  'pages.document.instruction.detail.timeInfo': '时间信息',
  'pages.document.instruction.detail.downloadFile': '下载文件',
  'pages.document.instruction.language.chinese': '中文',
  'pages.document.instruction.language.english': '英文',

  // 我的文档页面
  'pages.document.my-doc.title': '我的文档',
  'pages.document.my-doc.pageSubTitlePrivateNote': '此处的文档仅自己可见。',
  'pages.document.my-doc.create': '新增文档',
  'pages.document.my-doc.batchDelete': '批量删除',
  'pages.document.my-doc.confirmDelete': '确定要删除这条我的文档吗？',
  'pages.document.my-doc.confirmBatchDelete': '确定要删除选中的 {count} 条我的文档吗？',
  'pages.document.my-doc.deleteSuccess': '删除我的文档成功',
  'pages.document.my-doc.batchDeleteSuccess': '批量删除我的文档成功',
  'pages.document.my-doc.deleteFailed': '删除我的文档失败',
  'pages.document.my-doc.batchDeleteFailed': '批量删除我的文档失败',
  'pages.document.my-doc.getListFailed': '获取我的文档列表失败',
  'pages.document.my-doc.getDetailFailed': '获取我的文档详情失败',
  'pages.document.my-doc.selectDeleteWarning': '请选择要删除的我的文档',
  'pages.document.my-doc.columns.name': '文档名称',
  'pages.document.my-doc.columns.docType': '文档类型',
  'pages.document.my-doc.columns.mark': '文档分类',
  'pages.document.my-doc.columns.fileSize': '文件大小',
  'pages.document.my-doc.columns.status': '状态',
  'pages.document.my-doc.columns.description': '描述',
  'pages.document.my-doc.columns.createdBy': '创建人',
  'pages.document.my-doc.columns.createdTime': '创建时间',
  'pages.document.my-doc.columns.operations': '操作',
  'pages.document.my-doc.actions.view': '查看',
  'pages.document.my-doc.actions.edit': '编辑',
  'pages.document.my-doc.actions.delete': '删除',
  'pages.document.my-doc.status.enabled': '启用',
  'pages.document.my-doc.status.disabled': '停用',
  'pages.document.my-doc.detail.title': '我的文档详情',
  'pages.document.my-doc.detail.basicInfo': '基本信息',
  'pages.document.my-doc.detail.fileInfo': '文件信息',
  'pages.document.my-doc.detail.timeInfo': '时间信息',
  'pages.document.my-doc.detail.downloadFile': '下载文件',
  'pages.document.my-doc.language.chinese': '中文',
  'pages.document.my-doc.language.english': '英文',

  // 房主管理页面
  'pages.houseUser.title': '房主管理',
  'pages.houseUser.subTitle': '管理小区内的业主、租户和访客信息',
  'pages.houseUser.detail.title': '用户详情',
  'pages.houseUser.detail.breadcrumb': '用户详情',

  // 房主管理详情页 - Tab标签
  'pages.houseUser.detail.tab.properties': '用户属性',
  'pages.houseUser.detail.tab.houses': '房产信息',
  'pages.houseUser.detail.tab.rentInfo': '租房信息',
  'pages.houseUser.detail.tab.tenants': '租客管理',
  'pages.houseUser.detail.tab.parking': '停车位',
  'pages.houseUser.detail.tab.services': '开通服务',
  'pages.houseUser.detail.tab.contacts': '紧急联系人',

  // 房主管理详情页 - 卡片标题
  'pages.houseUser.detail.card.accountInfo': '账户信息',
  'pages.houseUser.detail.card.basicInfo': '基本信息',
  'pages.houseUser.detail.card.contactInfo': '联系方式',
  'pages.houseUser.detail.card.residenceInfo': '居住信息',
  'pages.houseUser.detail.card.remarks': '备注信息',
  'pages.houseUser.detail.card.parkingList': '停车位列表',

  // 房主管理详情页 - 描述项标签
  'pages.houseUser.detail.label.username': '用户名',
  'pages.houseUser.detail.label.role': '角色',
  'pages.houseUser.detail.label.status': '状态',
  'pages.houseUser.detail.label.name': '姓名',
  'pages.houseUser.detail.label.gender': '性别',
  'pages.houseUser.detail.label.birthDate': '出生日期',
  'pages.houseUser.detail.label.idCard': '身份证号',
  'pages.houseUser.detail.label.phone': '手机号码',
  'pages.houseUser.detail.label.email': '电子邮箱',
  'pages.houseUser.detail.label.moveInDate': '入住日期',
  'pages.houseUser.detail.label.moveOutDate': '搬出日期',
  'pages.houseUser.detail.label.postalCode': '邮政编码',
  'pages.houseUser.detail.label.address': '详细地址',

  // 房主管理详情页 - 按钮和操作
  'pages.houseUser.detail.button.edit': '编辑',
  'pages.houseUser.detail.button.view': '查看',
  'pages.houseUser.detail.button.addHouse': '+ 添加房屋',
  'pages.houseUser.detail.button.addContact': '添加联系人',
  'pages.houseUser.detail.button.addTenant': '+ 添加租客',
  'pages.houseUser.detail.button.unbind': '解绑',
  'pages.houseUser.detail.button.delete': '删除',

  // 房主管理详情页 - 房屋表格列
  'pages.houseUser.detail.table.house.buildingName': '楼栋名称',
  'pages.houseUser.detail.table.house.floor': '楼层',
  'pages.houseUser.detail.table.house.houseNumber': '房屋编号',
  'pages.houseUser.detail.table.house.houseType': '房屋类型',
  'pages.houseUser.detail.table.house.area': '房屋面积',
  'pages.houseUser.detail.table.house.status': '房屋状态',
  'pages.houseUser.detail.table.house.operations': '操作',

  // 房主管理详情页 - 紧急联系人表格列
  'pages.houseUser.detail.table.contact.contactName': '联系人姓名',
  'pages.houseUser.detail.table.contact.contactPhone': '联系人电话',
  'pages.houseUser.detail.table.contact.relationship': '与业主关系',
  'pages.houseUser.detail.table.contact.remarks': '备注',
  'pages.houseUser.detail.table.contact.createdTime': '创建时间',
  'pages.houseUser.detail.table.contact.operations': '操作',

  // 房主管理详情页 - 状态标签
  'pages.houseUser.detail.status.enabled': '正常',
  'pages.houseUser.detail.status.disabled': '禁用',
  'pages.houseUser.detail.status.other': '其他',
  'pages.houseUser.detail.status.active': '启用',
  'pages.houseUser.detail.status.inactive': '停用',
  'pages.houseUser.detail.status.available': '可用',
  'pages.houseUser.detail.status.sold': '已售',
  'pages.houseUser.detail.status.rented': '已租',
  'pages.houseUser.detail.status.reserved': '预留',
  'pages.houseUser.detail.status.expired': '已过期',
  'pages.houseUser.detail.status.pending': '未开始',
  'pages.houseUser.detail.status.expiring': '即将到期',
  'pages.houseUser.detail.status.vacant': '空置',
  'pages.houseUser.detail.status.occupied': '已出租',
  'pages.houseUser.detail.status.selfOccupied': '自住',
  'pages.houseUser.detail.status.underRepair': '维修',

  // 房主管理详情页 - 角色标签
  'pages.houseUser.detail.role.owner': '业主',
  'pages.houseUser.detail.role.tenant': '租户',
  'pages.houseUser.detail.role.visitor': '访客',

  // 房主管理详情页 - 房屋类型
  'pages.houseUser.detail.houseType.residential': '住宅',
  'pages.houseUser.detail.houseType.commercial': '商业',
  'pages.houseUser.detail.houseType.office': '办公',
  'pages.houseUser.detail.houseType.other': '其他',

  // 房主管理详情页 - 车位类型
  'pages.houseUser.detail.parkingType.ground': '地面车位',
  'pages.houseUser.detail.parkingType.underground': '地下车位',
  'pages.houseUser.detail.parkingType.mechanical': '机械车位',

  // 房主管理详情页 - 计费相关
  'pages.houseUser.detail.billingCycle.daily': '按日',
  'pages.houseUser.detail.billingCycle.monthly': '按月',
  'pages.houseUser.detail.billingCycle.quarterly': '按季度',
  'pages.houseUser.detail.billingCycle.yearly': '按年',
  'pages.houseUser.detail.billingUnit.month': '月',
  'pages.houseUser.detail.billingUnit.day': '日',
  'pages.houseUser.detail.billingUnit.year': '年',
  'pages.houseUser.detail.billingUnit.unit': '户',
  'pages.houseUser.detail.billingUnit.squareMeter': '平方米',

  // 房主管理详情页 - 消息提示
  'pages.houseUser.detail.message.updateSuccess': '更新成功',
  'pages.houseUser.detail.message.unbindSuccess': '解绑成功',
  'pages.houseUser.detail.message.unbindFailed': '解绑失败',
  'pages.houseUser.detail.message.deleteHouseSuccess': '删除房屋成功',
  'pages.houseUser.detail.message.deleteHouseFailed': '删除房屋失败',
  'pages.houseUser.detail.message.deleteContactSuccess': '删除紧急联系人成功',
  'pages.houseUser.detail.message.deleteContactFailed': '删除紧急联系人失败',
  'pages.houseUser.detail.message.loadHousesFailed': '加载房屋列表失败',
  'pages.houseUser.detail.message.loadParkingFailed': '加载停车位列表失败',
  'pages.houseUser.detail.message.loadContactsFailed': '加载紧急联系人列表失败',
  'pages.houseUser.detail.message.loadTenantsFailed': '加载租客列表失败',
  'pages.houseUser.detail.message.loadRentInfoFailed': '加载租房信息失败',
  'pages.houseUser.detail.message.loadServicesFailed': '加载已开通服务失败',

  // 房主管理详情页 - 确认对话框
  'pages.houseUser.detail.confirm.unbindRent.title': '确认解绑',
  'pages.houseUser.detail.confirm.unbindRent.content': '确定要解除该租房关系吗？',
  'pages.houseUser.detail.confirm.unbindTenant.title': '确认解绑',
  'pages.houseUser.detail.confirm.unbindTenant.content': '确定要解除与该租客的绑定关系吗？',
  'pages.houseUser.detail.confirm.deleteContact.title': '确认删除',
  'pages.houseUser.detail.confirm.deleteContact.content': '确定要删除这个紧急联系人吗？',
  'pages.houseUser.detail.confirm.okText': '确定',
  'pages.houseUser.detail.confirm.cancelText': '取消',

  // 房主管理详情页 - 空状态
  'pages.houseUser.detail.empty.noHouses': '暂无房产数据',
  'pages.houseUser.detail.empty.noRentInfo': '暂无租房信息',
  'pages.houseUser.detail.empty.noTenants': '暂无租客数据',
  'pages.houseUser.detail.empty.noParking': '暂无停车位数据',
  'pages.houseUser.detail.empty.noServices': '暂无已开通的服务',
  'pages.houseUser.detail.empty.noContacts': '暂无紧急联系人',

  // 房主管理详情页 - 其他文本
  'pages.houseUser.detail.loading': '加载中...',
  'pages.houseUser.detail.locationInfo': '位置信息',
  'pages.houseUser.detail.structureCode': '结构编码',
  'pages.houseUser.detail.parkingType': '车位类型',
  'pages.houseUser.detail.startTime': '开始时间',
  'pages.houseUser.detail.ownerInfo': '业主信息',
  'pages.houseUser.detail.tenantName': '租客姓名',
  'pages.houseUser.detail.houseInfo': '房屋信息',
  'pages.houseUser.detail.monthlyRent': '月租金',
  'pages.houseUser.detail.leaseStartDate': '租赁开始',
  'pages.houseUser.detail.leaseEndDate': '租赁结束',
  'pages.houseUser.detail.buildingName': '楼栋',
  'pages.houseUser.detail.floor': '楼层',
  'pages.houseUser.detail.houseNumber': '房屋号',
  'pages.houseUser.detail.area': '面积',
  'pages.houseUser.detail.amount': '金额',
  'pages.houseUser.detail.remarks': '备注',
  'pages.houseUser.detail.serviceCount': '服务数',
  'pages.houseUser.detail.bindVehicle': '已绑定车辆',
  'pages.houseUser.detail.noVehicle': '暂无绑定车辆',
  'pages.houseUser.detail.brandModel': '品牌/型号',
  'pages.houseUser.detail.vehicleColor': '车辆颜色',
  'pages.houseUser.detail.vehicleType': '车辆类型',
  'pages.houseUser.detail.registrationDate': '注册日期',
  'pages.houseUser.detail.bindVehicleButton': '+ 绑定车辆',
  'pages.houseUser.detail.editVehicleButton': '编辑',
  'pages.houseUser.detail.daysLeft': '即将到期({days}天)',

  // 物业费管理页面
  'pages.property-fee.title': '物业费',
  'pages.property-fee.subtitle': '管理小区物业费账单的生成、缴费和查询',
  'pages.property-fee.currentSelection': '当前选择：',
  'pages.property-fee.treeTitle': '楼栋楼层房屋选择',
  'pages.property-fee.batchCreate': '批量生成',
  'pages.property-fee.tabOther': '其他',
  'pages.property-fee.currency.php': '₱',
  'pages.property-fee.batchModal.title': '批量生成物业费账单',
  'pages.property-fee.batchModal.periodLabel': '选择账期',
  'pages.property-fee.batchModal.periodPlaceholder': '请选择账期',
  'pages.property-fee.batchModal.selectPeriodWarning': '请选择账期',
  'pages.property-fee.batchModal.confirmTitle': '确认批量生成',
  'pages.property-fee.batchModal.confirmContent': '确定要为账期 {period} 批量生成物业费账单吗？',
  'pages.property-fee.batchModal.success': '成功生成 {count} 条物业费账单',
  'pages.property-fee.batchModal.error': '批量生成失败',
  'pages.property-fee.batchModal.confirm': '确认',
  'pages.property-fee.batchModal.cancel': '取消',
  'pages.property-fee.batchModal.hint': '系统将根据房屋信息和物业费标准自动生成账单',
  'pages.property-fee.batchModal.hint2': '已生成的账单不会重复生成',
  'pages.property-fee.table.title': '物业费账单列表',
  'pages.property-fee.table.columns.houseNumber': '房屋编号',
  'pages.property-fee.table.columns.period': '账期',
  'pages.property-fee.table.columns.billNo': '账单号',
  'pages.property-fee.table.columns.ownerPhone': '业主电话',
  'pages.property-fee.table.columns.ownerIdCard': '身份证号',
  'pages.property-fee.table.columns.ownerEmail': '邮箱',
  'pages.property-fee.table.columns.totalAmount': '应收金额',
  'pages.property-fee.table.columns.approvalStatus': '审核状态',
  'pages.property-fee.table.columns.status': '缴费状态',
  'pages.property-fee.table.columns.paymentDate': '缴费日期',
  'pages.property-fee.table.columns.dueDate': '截止日期',
  'pages.property-fee.table.columns.operations': '操作',
  'pages.property-fee.table.actions.createBill': '新建账单',
  'pages.property-fee.table.actions.submitAudit': '提交审核',
  'pages.property-fee.table.actions.batchDelete': '批量删除',
  'pages.property-fee.table.actions.view': '查看',
  'pages.property-fee.table.actions.edit': '编辑',
  'pages.property-fee.table.actions.delete': '删除',
  'pages.property-fee.table.actions.cancel': '取消',
  'pages.property-fee.table.delete.confirm.content': '确定要删除这条账单吗？',
  'pages.property-fee.table.delete.confirm.title': '确定',
  'pages.property-fee.table.delete.success': '删除成功',
  'pages.property-fee.table.delete.error': '删除失败',
  'pages.property-fee.table.batchDelete.noSelection': '请选择要删除的账单',
  'pages.property-fee.table.batchDelete.confirm.title': '确认批量删除',
  'pages.property-fee.table.batchDelete.confirm.contentSimple': '确定要删除选中的 {count} 条账单吗？',
  'pages.property-fee.table.batchDelete.success': '批量删除成功',
  'pages.property-fee.table.batchDelete.error': '批量删除失败',
  'pages.property-fee.table.auditModal.title': '提交审核',
  'pages.property-fee.table.auditModal.auditName': '审核名称',
  'pages.property-fee.table.auditModal.auditNamePlaceholder': '请输入审核名称',
  'pages.property-fee.table.auditModal.auditNameRequired': '请输入审核名称',
  'pages.property-fee.table.auditModal.submitRemark': '提交备注',
  'pages.property-fee.table.auditModal.submitRemarkPlaceholder': '请输入提交备注',
  'pages.property-fee.table.auditModal.selectedBills': '已选择 {count} 条账单',
  'pages.property-fee.table.auditModal.defaultNameTemplate': '{period} 物业费账单({count}笔)',
  'pages.property-fee.table.auditModal.submit': '提交',
  'pages.property-fee.table.auditModal.noSelection': '请选择要审核的账单',
  'pages.property-fee.table.auditModal.success': '提交审核成功',
  'pages.property-fee.table.auditModal.error': '提交审核失败',
  'pages.property-fee.table.detail.title': '账单详情',
  'pages.property-fee.table.detail.close': '关闭',
  'pages.property-fee.table.detail.auditRecords': '审核记录',
  'pages.property-fee.table.detail.audit.loading': '加载中...',
  'pages.property-fee.table.detail.audit.noRecords': '暂无审核记录',
  'pages.property-fee.table.pagination.showTotal': '第 {start}-{end} 条，共 {total} 条',
  'pages.property-fee.status.unpaid': '未缴',
  'pages.property-fee.status.paid': '已缴',
  'pages.property-fee.status.overdue': '逾期',
  'pages.property-fee.status.partial': '部分缴',
  'pages.property-fee.status.cancelled': '已取消',
  'pages.property-fee.approvalStatus.draft': '草稿',
  'pages.property-fee.approvalStatus.pending': '待审核',
  'pages.property-fee.approvalStatus.approved': '已通过',
  'pages.property-fee.approvalStatus.rejected': '已拒绝',
  'pages.property-fee.approvalStatus.notified': '已通知',
  'pages.property-fee.approvalStatus.overdue': '逾期',
  'pages.property-fee.approvalStatus.cancelled': '已取消',
  'pages.property-fee.billingCycle.monthly': '月度',
  'pages.property-fee.billingCycle.quarterly': '季度',
  'pages.property-fee.billingCycle.semi_annual': '半年度',
  'pages.property-fee.billingCycle.yearly': '年度',
  'pages.breadcrumb.chargeManagement': '收费管理',
  'pages.breadcrumb.propertyFee': '物业费',

  // 电费管理页面
  'pages.electric-fee.title': '电费',
  'pages.electric-fee.subtitle': '管理小区电费账单的导入、缴费和查询',
  'pages.electric-fee.currentSelection': '当前选择：',
  'pages.electric-fee.treeTitle': '楼栋楼层房屋选择',
  'pages.electric-fee.batchImport': '批量导入',
  'pages.electric-fee.tabOther': '其他',
  'pages.electric-fee.floorSuffix': '楼',
  'pages.electric-fee.loadRecentMonths.comment': '加载最近6个月的时间列表',
  'pages.electric-fee.setDefaultTab.comment': '设置默认tab',
  'pages.electric-fee.setDefaultTab.defaultComment': '设置默认tab为当月',
  'pages.electric-fee.loadRecentMonths.error': '加载最近6个月时间列表失败',
  'pages.electric-fee.loadTreeData.comment': '加载楼栋楼层房屋树形数据',
  'pages.electric-fee.loadTreeData.error': '加载楼栋楼层房屋数据失败',
  'pages.electric-fee.expandFirstBuilding.comment': '默认展开第一个楼栋',
  'pages.electric-fee.activeTabChange.comment': '账期tab变化时刷新表格',
  'pages.electric-fee.treeSelect.comment': '树形选择处理',
  'pages.electric-fee.selectBuilding.comment': '选择楼栋',
  'pages.electric-fee.selectFloor.comment': '选择楼层',
  'pages.electric-fee.findBuildingName.comment': '找到楼栋名称',
  'pages.electric-fee.selectHouse.comment': '选择房屋',
  'pages.electric-fee.findBuildingFloorName.comment': '找到楼栋和楼层名称',
  'pages.electric-fee.refreshTable.comment': '刷新右侧表格',
  'pages.electric-fee.generateSubTitle.comment': '生成子标题',
  'pages.electric-fee.importSuccessCallback.comment': '导入成功回调',
  'pages.electric-fee.leftTree.comment': '左侧楼栋楼层树',
  'pages.electric-fee.rightList.comment': '右侧电费列表',
  'pages.electric-fee.batchImportModal.comment': '批量导入Modal',

};
